<template>
    <v-app>
        <router-view/>
        <AppServiceView></AppServiceView>
    </v-app>
</template>

<script>
import AppServiceView from '@/components/AppServiceView'

export default {
    components: { AppServiceView }
}
</script>
